import { sortObject } from '@s1/core/utilities';

/**
 * Retrieves vehicle makes and models
 *
 * @returns {Object}
 */
const getVehicleJSON = async () => {
  let json = {};

  try {
    // get vehicle json from cdn link
    const response = await fetch('https://cdn.carsgenius.com/carsgenius/wp-content/uploads/vehicles-home.json');
    json = await response.json();

    // sort makes and models alphabetically
    json = sortObject(json);
  } catch (err) {
    console.error(err);
  }

  return json;
};

export default getVehicleJSON;
